import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "case",
  "use": "case-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"case\"><path d=\"M12.6 2.8H9.8V1.4C9.8.623 9.177 0 8.4 0H5.6c-.777 0-1.4.623-1.4 1.4v1.4H1.4A1.39 1.39 0 0 0 .007 4.2L0 11.9c0 .777.623 1.4 1.4 1.4h11.2c.777 0 1.4-.623 1.4-1.4V4.2c0-.777-.623-1.4-1.4-1.4m-4.2 0H5.6V1.4h2.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol